export var EMPTY_TITLE_VERIFICATION_FILTERS = {
    name: "",
    issn: "",
    investigationStatus: "",
    publisher: "",
    provisional: false,
};
export var supportsIssnFilter = function (type) { return type === "PERIODICAL"; };
export var parseTitleVerificationFilters = function (search, type) {
    var params = new URLSearchParams(search);
    return {
        name: params.get("name") || "",
        issn: supportsIssnFilter(type) ? params.get("issn") || "" : "",
        investigationStatus: params.get("investigationStatus") || "",
        publisher: params.get("publisher") || "",
        provisional: params.get("provisional") === "true",
    };
};
export var toTitleVerificationUrlSearch = function (filters, type) {
    var params = new URLSearchParams();
    if (filters.name)
        params.set("name", filters.name);
    if (supportsIssnFilter(type) && filters.issn)
        params.set("issn", filters.issn);
    if (filters.investigationStatus)
        params.set("investigationStatus", filters.investigationStatus);
    if (filters.publisher)
        params.set("publisher", filters.publisher);
    if (filters.provisional)
        params.set("provisional", "true");
    return params.toString();
};
export var isAnyTitleVerificationFilterActive = function (filters, type) {
    return filters.name.length > 0 ||
        (supportsIssnFilter(type) && filters.issn.length > 0) ||
        filters.investigationStatus.length > 0 ||
        filters.publisher.length > 0 ||
        filters.provisional;
};
export var toTitleVerificationQueryParams = function (filters, type) { return ({
    search: filters.name.trim() || undefined,
    issn: supportsIssnFilter(type) ? filters.issn.trim() || undefined : undefined,
    investigationStatus: filters.investigationStatus || undefined,
    publisher: filters.publisher.trim() || undefined,
    provisional: filters.provisional || undefined,
}); };
var toInvestigationStatus = function (raw) {
    return raw === "NONE" || raw === "IN_PROGRESS" || raw === "RESOLVED"
        ? raw
        : undefined;
};
export var toTitleVerificationMatchFilter = function (filters, type) {
    var params = toTitleVerificationQueryParams(filters, type);
    return {
        search: params.search,
        issn: params.issn,
        investigationStatus: toInvestigationStatus(filters.investigationStatus),
        publisher: params.publisher,
        provisional: params.provisional,
        titleType: type,
    };
};
